import React, {useEffect, useState, useRef} from 'react';
import { Skeleton, Stack } from '@mui/material';
import { SchemaWithClient } from '../../../types/SchemaWithClient';
import { Entity } from '../../../types/entities/Entity';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../../Table/filters/TimeFilter';
import Box from '@mui/material/Box';
import { SPTextField } from '../../Table/fields/SPTextField';
import { SPRichTextField } from '../../Table/fields/SPRichTextField';
import { SPBooleanField } from '../../Table/fields/SPBooleanField';
import { SPNumberField } from '../../Table/fields/SPNumberField';
import {CustomFieldSPSelectField} from "../../Table/fields/CustomFiledSPSelectField";
import {enumItems} from "../../../schema/enumItems";

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};
export const CustomFields: FieldComponent<any, any> = ({
  onChange,
  isActive,
  value,
  defaultValue,
  hasTooltip,
  disabled,
  mui,
  column,
  allValue,
}) => {
  const [properties, setProperties] = useState<any>(undefined);
  const [loading, setLoading] = useState<any>(false);
  const ref = useRef();

  const customFieldsRef:any = useRef(null);

  useEffect(()=>{

    if (!defaultValue.length){

      if (customFieldsRef?.current){
        const closestParent = customFieldsRef.current?.closest('.MuiStack-root');
        const oneMoreLevelUp = closestParent?.parentElement;
        const oneMoreLevelUp1 = oneMoreLevelUp?.parentElement;

        oneMoreLevelUp1.style.display = 'none';
      }

    }

  },[])

  return (
    <>
      {loading ? (
        <>
          <Skeleton variant="rectangular" width={'100%'} height={30} />
        </>
      ) : (
        <>
          <Stack direction={'column'} ref={customFieldsRef} gap={0}>
            {!defaultValue ? <></> : <>
              {defaultValue.map((item: any, index: number) => {
                return (
                  <>
                    <Stack
                      key={index}
                      direction="row"
                      spacing={0}
                      sx={{
                        width: '100%',
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          borderBottom: '1px solid #dfdbdb',
                          background: '#f1f1f1',
                          borderRight: '1px solid #dfdbdb',
                          borderLeft: '1px solid #dfdbdb',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: {
                            xs: '15px',
                          },
                        }}
                      >
                        <span className={'px-[8px]'}>{`${item?.name}`}</span>
                      </Box>

                      <Box
                        sx={{
                          flex: 2,
                          borderBottom: '1px solid #dfdbdb',
                          borderRight: '1px solid #dfdbdb',
                          '& .MuiFormControl-root.MuiTextField-root': {
                            width: '100%',
                          },
                          width: '100%',
                          maxWidth: {
                            xs: 'calc(100% - 130px)',
                            md: 'calc(100% - 204px)',
                          },
                        }}
                      >
                        {item.type === 'string' && (
                          <SPTextField
                            defaultValue={allValue[`${item?.column_name}`]}
                            isActive={true}
                            onChange={(value) => {
                              if (onChange) {
                                onChange(value, item.column_name);
                              }
                            }}
                          />
                        )}

                        {item.type === 'text' && (
                          <SPRichTextField
                            defaultValue={allValue[`${item?.column_name}`]}
                            isActive={true}
                            onChange={(value) => {
                              if (onChange) {
                                onChange(value, item.column_name);
                              }
                            }}
                          />
                        )}

                        {item.type === 'boolean' && (
                          <SPBooleanField
                            defaultValue={allValue[`${item?.column_name}`]}
                            isActive={true}
                            onChange={(value) => {
                              if (onChange) {
                                onChange(value, item.column_name);
                              }
                            }}
                          />
                        )}
                        {item.type === 'float' && (
                          <SPNumberField
                            defaultValue={allValue[`${item?.column_name}`]}
                            isActive={true}
                            onChange={(value) => {
                              if (onChange) {
                                onChange(value, item.column_name);
                              }
                            }}
                          />
                        )}

                        {item.type === 'driver' && (
                          <CustomFieldSPSelectField
                            onChange={(value) => {
                              if (onChange) {
                                onChange(value.id, `${item.column_name}`);
                              }
                            }}
                            schema={enumItems.user}
                            defaultValue={allValue[`${item?.column_name}`]}
                            forcedValue={undefined}
                            disabled={false}
                            isMissing={false}
                            accordingToValue={undefined}
                          />
                        )}

                      </Box>
                    </Stack>
                  </>
                );
              })}
            </>}
          </Stack>
        </>
      )}
    </>
  );
};

CustomFields.includes = (query, value) => true;

CustomFields.comparator = () => 0;

CustomFields.FilterRenderer = TimeFilter;
